import type { ReactNode } from "react";

export type InfoModalContent = {
  children: ReactNode;
  onAction?: (actionName: string) => void;
};

// JSX and callbacks are non-serialisable, so keep them outside Redux state.
const infoModalContent = new Map<string, InfoModalContent>();
let nextInfoModalId = 0;

export const registerInfoModalContent = (content: InfoModalContent): string => {
  const id = `info-modal-${++nextInfoModalId}`;
  infoModalContent.clear();
  infoModalContent.set(id, content);
  return id;
};

export const getInfoModalContent = (id: string): InfoModalContent | undefined =>
  infoModalContent.get(id);

export const clearInfoModalContent = (): void => {
  infoModalContent.clear();
};
